if (!customElements.get('abode-hero-slideshow')) {
  class AbodeHeroSlideshow extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.timer = null;
    }

    connectedCallback() {
      this.slides = this.querySelectorAll('.abode-hero__slide');
      this.dots = this.querySelectorAll('.abode-hero__dot');
      this.autoplaySpeed = (parseInt(this.dataset.autoplay, 10) || 5) * 1000;

      if (this.slides.length <= 1) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goToSlide(parseInt(dot.dataset.dotIndex, 10));
        });
      });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());

      this.play();
    }

    disconnectedCallback() {
      this.pause();
    }

    play() {
      this.pause();
      this.timer = setInterval(() => {
        const next = (this.currentIndex + 1) % this.slides.length;
        this.goToSlide(next);
      }, this.autoplaySpeed);
    }

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;

      this.slides[this.currentIndex].classList.remove('is-active');
      this.dots[this.currentIndex].classList.remove('is-active');
      this.dots[this.currentIndex].setAttribute('aria-selected', 'false');

      this.currentIndex = index;

      this.slides[this.currentIndex].classList.add('is-active');
      this.dots[this.currentIndex].classList.add('is-active');
      this.dots[this.currentIndex].setAttribute('aria-selected', 'true');
    }
  }

  customElements.define('abode-hero-slideshow', AbodeHeroSlideshow);
}
